<template>
  <BoardView :title="$t('title')">
    <FormImages />
  </BoardView>
</template>

<script>
import BoardView from '@components/board/BoardView'
import FormImages from './components/FormImages'

export default {
  components: {
    BoardView,
    FormImages,
  },
}
</script>

<i18n>
{
  "en": {
    "title": "Upload images"
  }
}
</i18n>
